import axios from "axios";
import authHeader from "./auth-header";
import AuthService from "./auth.service";
import { config } from "../config";

class SupportService {
  startSupport(taskId) {
    return axios
      .patch(
        `${config["apiUrl"]}support/intervention/${taskId}/start`,
        {},
        {
          headers: authHeader(),
        }
      )
      .then((response) => {
        if (response.status == 200) {
          return response.data;
        }
        return null;
      })
      .catch((error) => {
        if (error.response && error.response.status == 401) {
          AuthService.logout();
          window.location = "/login";
        }
        throw error;
      });
  }

  revertStartSupport(taskId) {
    return axios
      .patch(
        `${config["apiUrl"]}support/intervention/${taskId}/revertStart`,
        {},
        {
          headers: authHeader(),
        }
      )
      .then((response) => {
        if (response.status == 200) {
          return response.data;
        }
        return null;
      })
      .catch((error) => {
        if (error.response.status == 401) {
          AuthService.logout();
          window.location = "/login";
        }
        console.log("ERROR:: ", error.response.data);
        return null;
      });
  }

  startSupportService(taskId) {
    return axios
      .patch(
        `${config["apiUrl"]}support/intervention/${taskId}/startService`,
        {},
        {
          headers: authHeader(),
        }
      )
      .then((response) => {
        if (response.status == 200) {
          return response.data;
        }
        return null;
      })
      .catch((error) => {
        if (error.response.status == 401) {
          AuthService.logout();
          window.location = "/login";
        }
        console.log("ERROR:: ", error.response.data);
        return null;
      });
  }

  updateEquipamentData(taskId, equipamentData) {
    return axios
      .patch(
        `${config["apiUrl"]}support/intervention/${taskId}/updateEquipamentData`,
        equipamentData,
        {
          headers: authHeader(),
        }
      )
      .then((response) => {
        if (response.status == 200) {
          return response.data;
        }
        return null;
      })
      .catch((error) => {
        if (error.response.status == 401) {
          AuthService.logout();
          window.location = "/login";
        }
        console.log("ERROR:: ", error.response.data);
        throw error.response;
      });
  }

  addInterventionPhotos(taskId, photos) {
    let headers = authHeader();
    headers['Content-Type'] = 'multipart/form-data';

    return axios
      .post(`${config["apiUrl"]}support/intervention/${taskId}/photos`, photos, {
        headers: headers})
      .then((response) => {
        if (response.status == 200) {
          return response.data;
        }
        return null;
      })
      .catch((error) => {
        if (error.response.status == 401) {
          AuthService.logout();
          window.location = "/login";
        }
        console.log("ERROR:: ", error.response.data);
        return null;
      });
  }

  addInterventionExtraPhotos(taskId, photos) {
    let headers = authHeader();
    headers['Content-Type'] = 'multipart/form-data';

    return axios
      .post(`${config["apiUrl"]}support/intervention/${taskId}/extraPhotos`, photos, {
        headers: headers})
      .then((response) => {
        if (response.status == 200) {
          return response.data;
        }
        return null;
      })
      .catch((error) => {
        if (error.response.status == 401) {
          AuthService.logout();
          window.location = "/login";
        }
        console.log("ERROR:: ", error.response.data);
        return null;
      });
  }

  addPartToIntervention(taskId, partInfo) {
    let headers = authHeader();

    return axios
      .post(`${config["apiUrl"]}support/intervention/${taskId}/addPart`, partInfo, {
        headers: headers})
      .then((response) => {
        if (response.status == 200) {
          return response.data;
        }
        return null;
      })
      .catch((error) => {
        if (error.response.status == 401) {
          AuthService.logout();
          window.location = "/login";
        }

        console.log("ERROR:: ", error.response.data);
        return error.response;
      });
  }

  getWorkSheet(taskId) {
    return axios
      .get(`${config["apiUrl"]}support/intervention/${taskId}/workSheet`, {
        headers: authHeader(),
      })
      .then((response) => {
        if (response.status == 200) {
          return response.data;
        }
        return null;
      })
      .catch((error) => {
        if (error.response.status == 401) {
          AuthService.logout();
          window.location = "/login";
        }
        console.log("ERROR:: ", error.response.data);
        return null;
      });
  }

  addReport(taskId, report) {
    return axios
      .patch(
        `${config["apiUrl"]}support/intervention/${taskId}/addReport`,
        report,
        {
          headers: authHeader(),
        }
      )
      .then((response) => {
        if (response.status == 200) {
          return response.data;
        }
        return null;
      })
      .catch((error) => {
        if (error.response.status == 401) {
          AuthService.logout();
          window.location = "/login";
        }
        console.log("ERROR:: ", error.response.data);
        return null;
      });
  }

  endService(taskId, report) {
    return axios
      .patch(
        `${config["apiUrl"]}support/intervention/${taskId}/endService`,
        report,
        {
          headers: authHeader(),
        }
      )
      .then((response) => {
        if (response.status == 200) {
          return response.data;
        }
        return null;
      })
      .catch((error) => {
        if (error.response.status == 401) {
          AuthService.logout();
          window.location = "/login";
        }
        console.log("ERROR:: ", error.response.data);
        return null;
      });
  }

  addInterventionClientSignature(taskId, data) {
    return axios
      .post(`${config["apiUrl"]}support/intervention/${taskId}/signature`,
        data,
        {
          headers: authHeader(),
        }
      )
      .then((response) => {
        if (response.status == 200) {
          return response.data;
        }
        return null;
      })
      .catch((error) => {
        if (error.response.status == 401) {
          AuthService.logout();
          window.location = "/login";
        }
        console.log("ERROR:: ", error.response.data);
        return null;
      });
  }

  generateReport(taskId) {
    return axios
      .get(`${config["apiUrl"]}support/intervention/${taskId}/generate-report`,
        {
          headers: authHeader(),
        }
      )
      .then((response) => {
        if (response.status == 200) {
          return response.data;
        }
        return null;
      })
      .catch((error) => {
        if (error.response.status == 401) {
          AuthService.logout();
          window.location = "/login";
        }
        console.log("ERROR:: ", error.response.data);

        if (Object.keys(error.response.data).includes('message')) {
          throw new Error(error.response.data.message);
        }

        return null;
      });
  }

  getInterventionTask(taskId) {
    return axios
      .get(`${config["apiUrl"]}support/intervention/${taskId}`,
        {
          headers: authHeader(),
        }
      )
      .then((response) => {
        if (response.status == 200) {
          return response.data;
        }
        return null;
      })
      .catch((error) => {
        if (error.response.status == 401) {
          AuthService.logout();
          window.location = "/login";
        }
        console.log("ERROR:: ", error.response.data);
        return null;
      });
  }

  sendReportToClient(taskId, data) {
    return axios
      .post(`${config["apiUrl"]}support/intervention/${taskId}/send-report-to-client`,
        data,
        {
          headers: authHeader(),
        }
      )
      .then((response) => {
        if (response.status == 200) {
          return response.data;
        }
        return null;
      })
      .catch((error) => {
        if (error.response.status == 401) {
          AuthService.logout();
          window.location = "/login";
        }
        console.log("ERROR:: ", error.response.data);
        return null;
      });
  }

  getPartsToUse(date) {
    return axios
      .post(`${config["apiUrl"]}support/intervention/parts-to-use`,
        {
          date: date
        },
        {
          headers: authHeader(),
        }
      )
      .then((response) => {
        if (response.status == 200) {
          return response.data;
        }
        return null;
      })
      .catch((error) => {
        if (error.response.status == 401) {
          AuthService.logout();
          window.location = "/login";
        }
        console.log("ERROR:: ", error.response.data);
        return null;
      });
  }

  saveReception(taskId, data) {
    return axios
      .post(
        `${config["apiUrl"]}support/intervention/${taskId}/reception`,
        data,
        {
          headers: authHeader(),
        }
      )
      .then((response) => {
        if (response.status == 201 || response.status == 200) {
          return response.data;
        }
        return null;
      })
      .catch((error) => {
        if (error.response.status == 401) {
          AuthService.logout();
          window.location = "/login";
        }
        throw error;
      });
  }

  checkReception(taskId) {
    return axios
      .get(
        `${config["apiUrl"]}support/intervention/${taskId}/reception/check`,
        {
          headers: authHeader(),
        }
      )
      .then((response) => {
        if (response.status == 200) {
          return response.data;
        }
        return null;
      })
      .catch((error) => {
        if (error.response.status == 401) {
          AuthService.logout();
          window.location = "/login";
        }
        return null;
      });
  }
}
export default new SupportService();
